import React from 'react';
import PropTypes from 'prop-types';
import Link from '~/components/link-with-previous-href';

const BodyTile = ({
  to,
  body,
  subtitle,
  className,
}) => pug`
  Link.tile.tile--body(to=to, className=className)
    .tile__content
      .tile__body=body
      if subtitle
        h5.tile__subtitle=subtitle
`;

BodyTile.defaultProps = { className: '' };

BodyTile.propTypes = {
  to: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  className: PropTypes.string,
};

export default BodyTile;
